import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ, SITE } from "@/lib/siteConfig";
import { Phone } from "lucide-react";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-white py-20 sm:py-28 reveal">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
              — Questions fréquentes
            </div>
            <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl uppercase leading-[0.95]">
              Tout ce que<br />vous voulez savoir.
            </h2>
            <p className="mt-5 text-slate-600 max-w-md">
              Une question ne trouve pas de réponse ? Appelez-nous, un conseiller humain
              vous répond immédiatement.
            </p>
            <a
              href={SITE.phoneHref}
              data-testid="call-cta-faq"
              className="mt-6 inline-flex items-center gap-2 text-red-600 font-display font-bold uppercase tracking-tight border-b-2 border-red-600 pb-1 hover:gap-3 transition-all"
            >
              <Phone className="w-4 h-4" strokeWidth={2.5} />
              {SITE.phone}
            </a>
          </div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {FAQ.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-black/10"
                >
                  <AccordionTrigger className="text-left font-display font-bold text-base sm:text-lg py-5 hover:no-underline hover:text-red-600">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
